<template>
  <v-dialog
    v-model="dialog"
    max-width="550px"
    scrollable
  >
    <v-card
      style="border-radius:20px;"
      class="py-2 strategio-card-container"
    >
      <!-- <v-container class="py-0"> -->
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >
        Permisos
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <v-layout column mb-3>
          <v-flex class="my-1">
            <v-layout align-center>
              <v-flex>
                <span class="body-1">Carpeta: </span>
                <span class="body-2">{{ totalHolder.folderName }}</span>
              </v-flex>
              <v-btn
                small rounded depressed
                color="success"
                class="strategio-dialog-button"
              >Agregar</v-btn>
            </v-layout>
          </v-flex>
          <v-flex>
            <template v-if="totalHolder.containedBy === 0">
            </template>
            <template v-else>
              <v-layout
                row wrap
                align-center
                class="pl-3"
                :key="index"
                v-for="(item, index) in correctUsersID(totalHolder.usersID)"
              >
                <v-flex xs12 sm12 md3>
                  <v-chip
                    label
                    small
                    :color="pickColor(getUserData(item).userType)"
                    class="ml-0"
                    style="font-style:italic;color:white;"
                  >{{ getUserData(item).userType }}</v-chip>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <span
                    class="grey--text"
                    style="font-weight:500;font-style:italic;"
                  >{{getUserData(item).name}}</span>
                </v-flex>

                <v-flex xs12 sm12 md6>
                  <span class="grey--text" style="font-style:italic;">{{getUserData(item).mail}}</span>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>
        </v-layout>
        <current-folder-permissions-tree
          :users="users"
          :items="totalHolder.folders"
          permissionsType="FOLDER"
        ></current-folder-permissions-tree>
        <current-folder-permissions-tree
          :users="users"
          :items="totalHolder.reports"
          permissionsType="REPORT"
        ></current-folder-permissions-tree>
      </v-card-text>
      <!-- <v-divider></v-divider> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small dark depressed rounded
          color="red"
          class="strategio-dialog-button"
          @click.native="dialog = false"
        >Cerrar</v-btn>
      </v-card-actions>

      <!-- </v-container> -->
    </v-card>
  </v-dialog>
</template>

<script>
import {find, flatMap, filter} from 'lodash'

import eventBus from './../../utils/eventBus'

import CurrentFolderPermissionsTree from './../folders/current-folder-permissions-tree'

export default {
  data () {
    return {
      dialog: false,
      users: [],
      totalHolder: [],
      pickColor (userType) {
        switch (userType) {
          case 'ADMIN': return 'blue darken-1'
          case 'SUPERVISOR': return 'amber darken-1'
          case 'GLOBAL': return 'light-green darken-1'
          case 'NORMAL': return 'cyan darken-1'
          case 'DEMO': return 'purple darken-1'
          default: return 'grey darken-1'
        }
      }
    }
  },
  created () {
    eventBus.$off('open-show-users-folder-permissions-dialog')
    eventBus.$on('open-show-users-folder-permissions-dialog', (totalHolder, users, isLoadingFalse) => {
      this.users = users
      this.totalHolder = totalHolder
      this.dialog = true

      isLoadingFalse()
    })
  },
  methods: {
    getUserData (userID) {
      return find(this.users, (user) => user.userID === userID)
    },
    correctUsersID (usersID) {
      flatMap(filter(this.users, (user) => {
        return ['SUPERVISOR', 'GLOBAL'].includes(user.userType)
      }), 'userID').forEach((userID) => {
        if (!usersID.includes(userID)) usersID.push(userID)
      })

      return usersID
    }
  },
  components: {
    CurrentFolderPermissionsTree
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/show-users-folder-permissions.vue